export default "__VITE_ASSET__CIIhBI1E__"